<div class="row mt-3" [formGroup]="form">
  <div class="col-md-12">
    <div class="card">
      <div class="float-start card-header card-header-detail" i18n>
        Personendaten der/des Stellvertretenden
      </div>

      <div class="card-body">
        <div class="row">
          <div class="col-md-4">
            <div class="mb-3">
              <app-input
                         [fieldId]="'antragsteller.stellvertreter.familienname'"
                         [type]="'text'"
                         [control]="form.get('familienname')"
                         label="Familienname:"
                         i18n-label
                         [toUpperCaseEnabled]="true"
                         [assistantServiceEnabled]="appConfig.isAssistantAvailable"
                         [saveLastFocusedEnabled]="true"
                         [popOverName]="'familienname'">
                <div *ngIf="model.isMek">
                  <span *ngIf="model.isCVisum" i18n>Bitte tragen Sie hier den Familiennamen des/der Stellvertretenden des/der Antragstellenden ein. Folgende (Sonder-)Zeichen sind zulässig: A..ZÄÖÜß'/- +.blank. Ziffern können nicht eingegeben werden.</span>
                  <span *ngIf="model.isDVisum" i18n>Bitte tragen Sie hier den Familiennamen des/der Stellvertretenden des/der Antragstellenden ein. Folgende (Sonder-)Zeichen sind zulässig: A..ZÄÖÜß'/- +.blank. Ziffern können nicht eingegeben werden.</span>
                </div>
                <div *ngIf="model.isVidex">
                  <span *ngIf="model.isCVisum" i18n>Bitte tragen Sie hier den Familiennamen des/der Stellvertretenden des/der Antragstellenden ein. Folgende (Sonder-)Zeichen sind zulässig: A..ZÄÖÜß'/- +.blank. Ziffern können nicht eingegeben werden.</span>
                  <span *ngIf="model.isDVisum" i18n>Bitte tragen Sie hier den Familiennamen des/der Stellvertretenden des/der Antragstellenden ein. Folgende (Sonder-)Zeichen sind zulässig: A..ZÄÖÜß'/- +.blank. Ziffern können nicht eingegeben werden.</span>
                </div>
              </app-input>
            </div>
          </div>
          <div class="col-md-4">
            <div class="mb-3">
              <app-input
                [fieldId]="'antragsteller.stellvertreter.vorname'"
                [type]="'text'"
                [control]="form.get('vorname')"
                label="Vorname(n):"
                i18n-label
                [toUpperCaseEnabled]="true"
                [assistantServiceEnabled]="appConfig.isAssistantAvailable"
                [saveLastFocusedEnabled]="true"
                [popOverName]="'vorname'">
                <div *ngIf="model.isMek">
                  <span *ngIf="model.isCVisum" i18n>Bitte tragen Sie hier den/die Vornamen des/der Stellvertretenden des/der Antragstellenden ein. Folgende (Sonder-)Zeichen sind zulässig: A..ZÄÖÜß'/- +.blank. Ziffern können nicht eingegeben werden.</span>
                  <span *ngIf="model.isDVisum" i18n>Bitte tragen Sie hier den/die Vornamen des/der Stellvertretenden des/der Antragstellenden ein. Folgende (Sonder-)Zeichen sind zulässig: A..ZÄÖÜß'/- +.blank. Ziffern können nicht eingegeben werden.</span>
                </div>
                <div *ngIf="model.isVidex">
                  <span *ngIf="model.isCVisum" i18n>Bitte tragen Sie hier den/die Vornamen des/der Stellvertretenden des/der Antragstellenden ein. Folgende (Sonder-)Zeichen sind zulässig: A..ZÄÖÜß'/- +.blank. Ziffern können nicht eingegeben werden.</span>
                  <span *ngIf="model.isDVisum" i18n>Bitte tragen Sie hier den/die Vornamen des/der Stellvertretenden des/der Antragstellenden ein. Folgende (Sonder-)Zeichen sind zulässig: A..ZÄÖÜß'/- +.blank. Ziffern können nicht eingegeben werden.</span>
                </div>
              </app-input>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <div class="mb-3">
              <app-input
                [fieldId]="'antragsteller.stellvertreter.anschrift'"
                [type]="'text'"
                [control]="form.get('anschrift')"
                label="Anschrift:"
                i18n-label
                [toUpperCaseEnabled]="true"
                [assistantServiceEnabled]="appConfig.isAssistantAvailable"
                [saveLastFocusedEnabled]="true"
                [popOverName]="'anschrift'">
                <div *ngIf="model.isMek">
                  <span *ngIf="model.isCVisum" i18n>Bitte tragen Sie hier die aktuelle Wohnanschrift des/der Stellvertretenden des/der Antragstellenden ein.</span>
                  <span *ngIf="model.isDVisum" i18n>Bitte tragen Sie hier die aktuelle Wohnanschrift des/der Stellvertretenden des/der Antragstellenden ein.</span>
                </div>
                <div *ngIf="model.isVidex">
                  <span *ngIf="model.isCVisum" i18n>Bitte tragen Sie hier die aktuelle Wohnanschrift des/der Stellvertretenden des/der Antragstellenden ein.</span>
                  <span *ngIf="model.isDVisum" i18n>Bitte tragen Sie hier die aktuelle Wohnanschrift des/der Stellvertretenden des/der Antragstellenden ein.</span>
                </div>
              </app-input>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-4">
            <div class="mb-3">
              <app-input
                [fieldId]="'antragsteller.stellvertreter.telefon'"
                [type]="'text'"
                [control]="form.get('telefon')"
                label="Telefon-/Mobilfunknummer:"
                i18n-label
                [toUpperCaseEnabled]="true"
                [assistantServiceEnabled]="appConfig.isAssistantAvailable"
                [saveLastFocusedEnabled]="true"
                [popOverName]="'telefon'">
                <div *ngIf="model.isMek">
                  <span *ngIf="model.isCVisum" i18n>Bitte tragen Sie hier die aktuelle Telefonnummer des/der Stellvertretenden des/der Antragstellenden ein.</span>
                  <span *ngIf="model.isDVisum" i18n>Bitte tragen Sie hier die aktuelle Telefonnummer des/der Stellvertretenden des/der Antragstellenden ein.</span>
                </div>
                <div *ngIf="model.isVidex">
                  <span *ngIf="model.isCVisum" i18n>Bitte tragen Sie hier die aktuelle Telefonnummer des/der Stellvertretenden des/der Antragstellenden ein.</span>
                  <span *ngIf="model.isDVisum" i18n>Bitte tragen Sie hier die aktuelle Telefonnummer des/der Stellvertretenden des/der Antragstellenden ein.</span>
                </div>
              </app-input>
            </div>
          </div>
          <div class="col-md-4">
            <div class="mb-3">
              <app-input
                [fieldId]="'antragsteller.stellvertreter.email'"
                [type]="'text'"
                [control]="form.get('email')"
                label="E-Mail:"
                i18n-label
                [toUpperCaseEnabled]="true"
                [assistantServiceEnabled]="appConfig.isAssistantAvailable"
                [saveLastFocusedEnabled]="true"
                [popOverName]="'email'">
                <div *ngIf="model.isMek">
                  <span *ngIf="model.isCVisum" i18n>Bitte tragen Sie hier die aktuelle E-Mail-Adresse des/der Stellvertretenden des/der Antragstellenden ein.</span>
                  <span *ngIf="model.isDVisum" i18n>Bitte tragen Sie hier die aktuelle E-Mail-Adresse des/der Stellvertretenden des/der Antragstellenden ein.</span>
                </div>
                <div *ngIf="model.isVidex">
                  <span *ngIf="model.isCVisum" i18n>Bitte tragen Sie hier die aktuelle E-Mail-Adresse des/der Stellvertretenden des/der Antragstellenden ein.</span>
                  <span *ngIf="model.isDVisum" i18n>Bitte tragen Sie hier die aktuelle E-Mail-Adresse des/der Stellvertretenden des/der Antragstellenden ein.</span>
                </div>
              </app-input>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
